import React from 'react';
import './App.scss';

function Skills() {
  return (
    <>
      <div className='title-box'>
        <p className='subtitle'>What Skills I Have</p>
        <p className='title'>Habilidades</p>
      </div>
      <div className='skills'>
        <div className='box-experience'>
          <p className='title'>Expertise em UI/UX</p>
          <ul>
            <li>Prototipação de sistemas Web e Mobile utilizando figma</li>
            <li>Criação de diagrama que mapeia cada etapa que um usuário</li>
            <li>Design de aplicativo</li>
          </ul>
        </div>
        <div className='box-experience'>
          <p className='title'>Desenvolvimento de sistemas</p>
          <ul>
            <li>Desenvolvimento de sistemas Web e Mobile</li>
            <li>Otimização e melhoria de código</li>
            <li>Criação de funcionalidades de manipulação de elementos 3D</li>
            <li>Desenvolvimento de sistemas responsivos</li>
            <li>Tratamento de grandes volumes de dados</li>
            <li>PostgreSQL, SQL e CouchDB</li>
          </ul>
        </div>
        <div className='box-experience'>
          <p className='title'>Competências</p>
          <ul>
            <li>Trabalho em equipe usando a metodologia scrum, realizando code review dos outros colaborares</li>
            <li>Inglês em todos os processos</li>
            <li>Teste e depuração de software</li>
            <li>Implementação de melhorias no sistema</li>
            <li>Boas práticas de segurança da informação</li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Skills;